import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export const convertStringToSelectOption = (item: string): ISelectOption<string> => ({
  id: item,
  label: item,
  value: item,
});
